import React, { Component } from "react";
import PropTypes from "prop-types";
import { Form, Row, Col, Button } from "react-bootstrap";
import { Formik } from "formik";

// Helper
import yup from "../../../helpers/Validation";

class Step2 extends Component {
  constructor(props) {
    super(props);

    this.state = {
      verificationCodeSent: false,
      invalidVerificationCode: false,
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.verificationCodeSent !== this.props.verificationCodeSent) {
      if (this.props.verificationCodeSent) {
        this.fm_code1.focus();
      }
    }

    if (prevProps.codeNotVerified !== this.props.codeNotVerified) {
      if (this.props.codeNotVerified) {
        if (this.props.codeNotVerified) {
          this.setState({ invalidVerificationCode: true });
        }
      }
    }
  }

  _onBack = () => {
    const form = this.form;
    const values = form.state.values;

    this.props.onBack(values, "1");
  };

  _onSubmit = (data) => {
    this.props.onSubmit(data);
  };

  _validationSchema = () => {
    return yup.object({
      code1: yup.string().required(),
      code2: yup.string().required(),
      code3: yup.string().required(),
      code4: yup.string().required(),
    });
  };

  _handleSubmit = () => {
    const form = this.form;
    const { errors } = form.state;

    let valid = JSON.stringify(errors) === JSON.stringify({});
    if (!valid) {
      // Scroll to first invalid element
      let firstError = Object.keys(errors)[0];
      let refName = "fm_" + firstError;

      if (this[refName]) {
        // window.scrollTo(0, this[refName].offsetTop + 110);
      } else {
        // console.log("Error: Field not found. " + refName);
      }
    }
  };

  _handleChangeCode = (name, e) => {
    const form = this.form;
    const value = e.target.value;

    if (value.length === 2) {
      form.setFieldValue(name, value.charAt(1));
    } else {
      form.setFieldValue(name, value);
    }

    switch (name) {
      case "code1":
        value !== "" && this.fm_code2.focus();
        break;
      case "code2":
        value === "" ? this.fm_code1.focus() : this.fm_code3.focus();
        break;
      case "code3":
        value === "" ? this.fm_code2.focus() : this.fm_code4.focus();
        break;
      case "code4":
        value === "" && this.fm_code3.focus();
        break;
      default:
        break;
    }

    if (this.state.invalidVerificationCode) {
      this.setState({ invalidVerificationCode: false });
    }
  };

  render() {
    const { data, resendTime, verificationCodeSent, codeVerified } = this.props;
    const { invalidVerificationCode } = this.state;
    return (
      <Formik
        ref={(el) => (this.form = el)}
        validationSchema={this._validationSchema}
        onSubmit={this._onSubmit}
        initialValues={data}
        validateOnBlur={true}
      >
        {({
          validateForm,
          handleSubmit,
          handleChange,
          handleBlur,
          values,
          isValid,
          isSubmitting,
          submitCount,
          touched,
          dirty,
          errors,
        }) => {
          return (
            <Form
              noValidate
              className="h-100 d-flex flex-column flex-grow-1 justify-content-between"
              onSubmit={handleSubmit}
            >
              <h3>Step 2</h3>
              <h5>
                Please enter verification code that has been sent to your phone
                number.
              </h5>
              <div className="flex-grow-1">
                <Form.Group>
                  <Form.Label>Phone No.</Form.Label>
                  <Form.Control
                    plaintext
                    readOnly
                    defaultValue={`(${values.country_code}) ${values.phone_no}`}
                    className="text-readonly"
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Label>Verification Code</Form.Label>
                  <Form.Row>
                    <Col controlid="validationCode1">
                      <Form.Control
                        type="tel"
                        name="code1"
                        value={values.code1}
                        disabled={!verificationCodeSent || codeVerified}
                        onChange={(e) => {
                          this._handleChangeCode("code1", e);
                        }}
                        onBlur={handleBlur}
                        maxLength={2}
                        className="text-center"
                        ref={(ref) => {
                          this.fm_code1 = ref;
                        }}
                      />
                    </Col>
                    <Col controlid="validationCode2">
                      <Form.Control
                        type="tel"
                        name="code2"
                        value={values.code2}
                        disabled={!verificationCodeSent || codeVerified}
                        onChange={(e) => {
                          this._handleChangeCode("code2", e);
                        }}
                        onBlur={handleBlur}
                        maxLength={2}
                        className="text-center"
                        ref={(ref) => {
                          this.fm_code2 = ref;
                        }}
                      />
                    </Col>
                    <Col controlid="validationCode3">
                      <Form.Control
                        type="tel"
                        name="code3"
                        value={values.code3}
                        disabled={!verificationCodeSent || codeVerified}
                        onChange={(e) => {
                          this._handleChangeCode("code3", e);
                        }}
                        onBlur={handleBlur}
                        maxLength={2}
                        className="text-center"
                        ref={(ref) => {
                          this.fm_code3 = ref;
                        }}
                      />
                    </Col>
                    <Col controlid="validationCode4">
                      <Form.Control
                        type="tel"
                        name="code4"
                        value={values.code4}
                        disabled={!verificationCodeSent || codeVerified}
                        onChange={(e) => {
                          this._handleChangeCode("code4", e);
                        }}
                        onBlur={handleBlur}
                        maxLength={2}
                        className="text-center"
                        ref={(ref) => {
                          this.fm_code4 = ref;
                        }}
                      />
                    </Col>
                  </Form.Row>

                  {!invalidVerificationCode ? (
                    touched.code1 &&
                    touched.code2 &&
                    touched.code3 &&
                    touched.code4 &&
                    (errors.code1 ||
                      errors.code2 ||
                      errors.code3 ||
                      errors.code4) && (
                      <div className="error">
                        Please enter valid verification code.
                      </div>
                    )
                  ) : (
                    <div className="error">Invalid verification code.</div>
                  )}
                </Form.Group>
                <Button
                  variant="outline-primary"
                  size="sm"
                  onClick={this.props.onSendCode}
                  disabled={verificationCodeSent && resendTime !== 0}
                >
                  {"Click to " +
                    (verificationCodeSent
                      ? `Resend${
                          resendTime !== 0 ? " (" + resendTime + ")" : ""
                        }`
                      : "Send Code")}
                </Button>
              </div>
              <Row>
                <Col>
                  <Button
                    className="mt-4"
                    variant="light"
                    block
                    onClick={this._onBack}
                  >
                    Back
                  </Button>
                </Col>
                <Col>
                  <Button
                    type="submit"
                    variant="primary"
                    className="mt-4"
                    block
                    disabled={isSubmitting}
                    onClick={() => {
                      if (submitCount === 0) {
                        validateForm().then(() => {
                          this._handleSubmit();
                        });
                      } else {
                        this._handleSubmit();
                      }
                    }}
                  >
                    Next
                  </Button>
                </Col>
              </Row>
            </Form>
          );
        }}
      </Formik>
    );
  }
}

Step2.propTypes = {
  data: PropTypes.object.isRequired,
  resendTime: PropTypes.number.isRequired,
  verificationCodeSent: PropTypes.bool.isRequired,
  codeVerified: PropTypes.bool.isRequired,
  // Function
  onSendCode: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default Step2;
